Namespace 'Monitoring.Views.Dashboards.Modes'

class Monitoring.Views.Dashboards.Modes.DomainExplorerView extends Backbone.View

  template: JST["backbone/templates/monitoring/dashboards/modes/domain_explorer/index"]

  switchmodeEventByModeId: {
    text: 'showTextMode',
    visual: 'showVisualMode',
    assistant: 'showAssistantMode'
  }

  initialize: ({ searchQuery, submodesPermissions }) ->
    @searchQuery = searchQuery
    @vueDomainExplorerComponent = new VueInBackbone.VueApp('domain-explorer',
      {
        searchQuery: searchQuery.toJSON(),
        show: false,
        permissions: submodesPermissions
      }
    )
    @vueDomainExplorerComponent.on('change-mode', @changeMode)
    @vueDomainExplorerComponent.on('open-in-new-session', @openNewSession)

  render: ->
    @$el.html(@template)
    @$el.find('.domain-explorer-section').append(@vueDomainExplorerComponent.el)
    @vueDomainExplorerComponent.render()
    @

  show: ->
    @vueDomainExplorerComponent.update({ show: true })

  update: (searchQuery) ->
    @searchQuery = searchQuery
    @vueDomainExplorerComponent.update({ searchQuery: searchQuery.toJSON() })

  changeMode: (modeId) =>
    @trigger('showFilters')
    @trigger(@switchmodeEventByModeId[modeId])

  openNewSession: (serializedSearchQuery) =>
    query = @searchQuery.deepCopy()
    query.set(serializedSearchQuery)

    @eventAggregator.trigger('clickOnCloneDashboard', query)

  destroy: ->
    @remove()

  remove: ->
    @vueDomainExplorerComponent.remove()
    super()
